import { Code } from '@main/complykit/components/code';
import { Link } from '@main/complykit/components/link';
import { Fragment, ReactNode } from 'react';

/**
 * A connector hint as inline runs, for a field's description: code spans and
 * links inline, each line break kept as a break. A description takes inline
 * content only (field.md), so a hint never renders as blocks.
 */
export function MarkdownInline({ text }: { text: string }) {
  return text.split('\n').map((line, index) => (
    <Fragment key={index}>
      {index > 0 && <br />}
      {parseMarkdownInline(line)}
    </Fragment>
  ));
}

export function parseMarkdownInline(text: string) {
  const parts: ReactNode[] = [];
  const pattern = /\[([^\]]+)\]\(([^)]+)\)|`([^`]+)`/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null = null;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const [, label, href, code] = match;
    if (label && href) {
      parts.push(
        <Link key={match.index} href={href} target="_blank" size="inherit">
          {label}
        </Link>,
      );
    } else if (code) {
      parts.push(<Code key={match.index}>{code}</Code>);
    }
    lastIndex = pattern.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}
